import React, { useState } from "react";
import { Tabs, Tab } from "@material-ui/core";
import { Box } from "@material-ui/core";

const CallDetailsTabs = ({ callItems = [], cdnURL = "", emptyMessage = "No call records available.", onRefresh, leadId }) => {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  if (!callItems || callItems.length === 0) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "48px 24px",
          color: "#6b7280",
          fontSize: 14,
        }}
      >
        {emptyMessage}
      </div>
    );
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <Tabs
        value={activeTab}
        onChange={handleTabChange}
        indicatorColor="primary"
        textColor="primary"
        variant="scrollable"
        scrollButtons="auto"
        style={{ borderBottom: "1px solid #e5e7eb" }}
      >
        {callItems.map((item, index) => (
          <Tab
            key={index}
            label={`Call ${index + 1}`}
            style={{
              textTransform: "none",
              fontSize: 14,
              fontWeight: activeTab === index ? 600 : 400,
              minWidth: 100,
            }}
          />
        ))}
      </Tabs>

      <Box
        style={{
          flex: 1,
          overflow: "auto",
          padding: "24px",
        }}
      >
        {callItems[activeTab] && (
          <div>
            <div style={{ marginBottom: 16 }}>
              <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 4 }}>Call Date</div>
              <div style={{ fontWeight: 600, color: "#111827" }}>
                {callItems[activeTab].createdAt
                  ? new Date(callItems[activeTab].createdAt).toLocaleString()
                  : callItems[activeTab].date || "-"}
              </div>
            </div>

            {callItems[activeTab].transcript && (
              <div style={{ marginBottom: 16 }}>
                <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 8 }}>Transcript</div>
                <div
                  style={{
                    background: "#f9fafb",
                    borderRadius: 8,
                    padding: 16,
                    fontSize: 14,
                    color: "#374151",
                    lineHeight: 1.6,
                    whiteSpace: "pre-wrap",
                  }}
                >
                  {callItems[activeTab].transcript}
                </div>
              </div>
            )}

            {callItems[activeTab].audioUrl && (
              <div style={{ marginBottom: 16 }}>
                <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 8 }}>Audio Recording</div>
                <audio controls style={{ width: "100%" }}>
                  <source src={callItems[activeTab].audioUrl.startsWith("http") ? callItems[activeTab].audioUrl : `${cdnURL}${callItems[activeTab].audioUrl}`} type="audio/mpeg" />
                  Your browser does not support the audio element.
                </audio>
              </div>
            )}

            {callItems[activeTab].summary && (
              <div style={{ marginBottom: 16 }}>
                <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 8 }}>Summary</div>
                <div
                  style={{
                    background: "#f9fafb",
                    borderRadius: 8,
                    padding: 16,
                    fontSize: 14,
                    color: "#374151",
                    lineHeight: 1.6,
                  }}
                >
                  {callItems[activeTab].summary}
                </div>
              </div>
            )}

            {onRefresh && (
              <div style={{ marginTop: 24 }}>
                <button
                  onClick={onRefresh}
                  style={{
                    backgroundColor: "#7c3aed",
                    color: "#ffffff",
                    border: "none",
                    borderRadius: 6,
                    padding: "8px 20px",
                    fontSize: 13,
                    fontWeight: 600,
                    cursor: "pointer",
                  }}
                >
                  Refresh
                </button>
              </div>
            )}
          </div>
        )}
      </Box>
    </div>
  );
};

export default CallDetailsTabs;

